import React from "react";
import {
  Button, DialogActions, DialogContent, Grid
} from '@mui/material';
import TextInput from "@/common/components/text-input/text-input";
import Dropdown from "@/common/components/dropdown/dropdown";
import SwitchInput from "@/common/components/switch-input/switch-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from 'react-intl';
import useCreateEditCategoryMaster from "./hooks/useCreateEditCategoryMaster";
import useGetBrandNameOptions from "@/common/hooks/useGetBrandMaster";
import PropTypes from "prop-types";
import { apiStatuses } from "@/store/api/constants";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";
import Spinner from "@/common/components/spinner/spinner";

function CreateEditCategoryMaster({
  closeModal, activeEditId
}) {

  const { getBrandNameOptions, getBrandNameLoading } = useGetBrandNameOptions();
  const {
    values, formik, getEditCategoryMasterStatus, getEditCategoryMasterErrMsg, 
    saveCategoryMasterStatus, updateCategoryMasterStatus} =
     useCreateEditCategoryMaster(activeEditId);
  const isPending = [saveCategoryMasterStatus, updateCategoryMasterStatus]
  .includes(apiStatuses.pending);

  const {
    categoryCode,categoryShortCode,categoryName, brandId, activeStatus
  } = values;

  return (
    <>
      {
        getEditCategoryMasterStatus === apiStatuses.pending && activeEditId
        && <Spinner />
      }

      {getEditCategoryMasterStatus === apiStatuses.rejected && activeEditId && (
        <ErrorInPage message={getEditCategoryMasterErrMsg} />
      )}

      {(getEditCategoryMasterStatus === apiStatuses.succeeded || !activeEditId) &&
        <form onSubmit={formik.handleSubmit}>
          <DialogContent dividers>
            <Grid container spacing={1.25}>
            <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="category-name" size="small" fullWidth
                  value={categoryName}
                  inputLabel="category-name"
                  formik={formik}
                  name="categoryName"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="category-code" size="small" fullWidth
                  value={categoryCode}
                  inputLabel="category-code"
                  formik={formik}
                  name="categoryCode"
                />
              </Grid>
                 <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="category-short-code" size="small" fullWidth
                  value={categoryShortCode}
                  inputLabel="category-short-code"
                  formik={formik}
                  name="categoryShortCode"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <Dropdown
                  options={getBrandNameOptions}
                  loading={getBrandNameLoading}
                  placeholder="brand-name"
                  inputLabel="brand-name"
                  value={brandId}
                  formik={formik}
                  name="brandId"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6}>
                <SwitchInput
                  inputLabel="activeStatus"
                  leftLabel="inactive"
                  rightLabel="active"
                  value={activeStatus}
                  formik={formik}
                  name="activeStatus"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="error" onClick={closeModal} disabled={isPending}
             variant="outlined" sx={{ mr: 1 }}>
              <FormattedMessage id={"cancel"} />
            </Button>
            <AnimateButton>
              <Button type="submit" variant="contained" disabled={isPending} sx={{ mr: 1 }}>
                <FormattedMessage id={"save"} />
              </Button>
            </AnimateButton>
          </DialogActions>
        </form>
      }
    </>
  )
}


CreateEditCategoryMaster.propTypes = {
  closeModal: PropTypes.func.isRequired,
  activeEditId: PropTypes.bool,
};

CreateEditCategoryMaster.defaultProps = {
  activeEditId: 0,
};


export default CreateEditCategoryMaster;